export default {
  parameterDatabase: 'Database Parameter',
  parameterName: 'Nama Parameter',
  info: 'Keterangan',
  searchText: 'Cari Nama Parameter',
  edit: 'Ubah',
  parameterFor: 'Parameter Untuk',
  value: 'Value',
  aktif: 'Aktif',
  expired: 'Kedaluwarsa',
  title: 'Ubah Force Update Android',
  isString: 'String'
}
